import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconAdjustedDown = ({ color = 'var(--color-accent-1-rgb)' }: IconProps): JSX.Element => {
    const mainColor = `rgb(${color})`;
    const secondColor = `rgba(${color}, 0.3)`;
    return (
        <div className="icon-block">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.26111 14.5568C1.01633 14.8194 1.03077 15.2307 1.29336 15.4755C1.55595 15.7203 1.96725 15.7059 2.21203 15.4433L1.26111 14.5568ZM13.0441 3.82309C13.2888 3.56051 13.2744 3.1492 13.0118 2.90442C12.7492 2.65964 12.3379 2.67408 12.0931 2.93667L13.0441 3.82309ZM2.21203 15.4433L13.0441 3.82309L12.0931 2.93667L1.26111 14.5568L2.21203 15.4433Z"
                    fill={mainColor} />
                <path d="M3.52979 1.93774V7.3635" stroke={secondColor} strokeWidth="1.3" strokeLinecap="round" />
                <path d="M6.05786 4.65112L1.00011 4.65112" stroke={secondColor} strokeWidth="1.3" strokeLinecap="round" />
                <path d="M15.1577 13.48L10.1 13.48" stroke={mainColor} strokeWidth="1.3" strokeLinecap="round" />
            </svg>
        </div>
    );
}

export default IconAdjustedDown;
